import axiosHttp from 'axios';
import { AppUrls } from 'common/constants/AppUrl';
import { useIframeMessageListener } from 'contexts/IframeMessageListener';
import { TOKENS } from 'pages/auth/constants';
import { initLogin } from 'pages/auth/hooks/useAuthSass/utils';
import { PropsWithChildren, useCallback, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { RootState } from 'store';
import { useMasterSiteChange } from 'ui/components/SitePicker/useMasterSiteChange';
import { postIframeMessage } from 'utils/postPerentIframeMessage';

export function IframeRouter({ children }: PropsWithChildren<{}>) {
  const location = useLocation();
  const navigate = useNavigate();
  useMasterSiteChange();
  const isMasterSlaveLoaded = useSelector((state: RootState) =>
    Boolean(state.masterSlave.masterSlave.CurrentSiteGlobalGuid)
  );
  const isUserLoaded = useSelector((state: RootState) => Boolean(state.user.loggedUser.clientId));

  const isFirstLoadedRef = useRef(true);

  const parentNavigateTo = useCallback(
    ({ path }: { path: string }) => {
      window.scrollTo(0, 0);
      if (path === location.pathname) return;

      navigate(path);
    },
    [location.pathname, navigate]
  );

  useIframeMessageListener('parentNavigateTo', parentNavigateTo);

  useEffect(() => {
    if (!isMasterSlaveLoaded || !isUserLoaded || !isFirstLoadedRef.current) return;
    isFirstLoadedRef.current = false;
    postIframeMessage('onMasterSlaveLoaded');
  }, [isMasterSlaveLoaded, isUserLoaded]);

  const refreshToken = useCallback(
    async ({ A_T, A_T_E, userGuid }: { A_T: string; A_T_E: string; userGuid: string }) => {
      // eslint-disable-next-line no-console
      console.log('IframeRouter refreshToken', { A_T, A_T_E });
      window.localStorage.setItem(TOKENS.AUTH_TOKEN_SESSION_KEY, A_T);
      window.localStorage.setItem(TOKENS.ACCESS_TOKEN_EXPIRATION, A_T_E);
      await initLogin(axiosHttp, userGuid);
      window.location.reload();
    },
    []
  );

  useIframeMessageListener('refreshToken', refreshToken);

  useEffect(() => {
    postIframeMessage('onIframeLoad');
  }, []);

  useEffect(() => {
    postIframeMessage('childNavigateToLog', { path: location.pathname, search: location.search });

    if (location.pathname !== AppUrls.SitePages.InitializationPage)
      postIframeMessage('childNavigateTo', { path: location.pathname, search: location.search });
  }, [location.pathname, location.search]);

  return <>{children}</>;
}
